var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8853 22.7565L20.5767 18.9698C20.7085 18.8453 20.7817 18.6549 20.7817 18.4865C20.7817 18.0983 20.5181 17.8419 20.1372 17.8419C19.9468 17.8419 19.8076 17.9005 19.6831 18.025L18.1597 19.5997L16.9805 20.9694L17.0464 19.2775V9.86584C17.0464 9.48499 16.7754 9.20667 16.3945 9.20667C16.0063 9.20667 15.7354 9.48499 15.7354 9.86584V19.2775L15.8086 20.9694L14.6294 19.5997L13.106 18.025C12.9814 17.9005 12.835 17.8419 12.6519 17.8419C12.271 17.8419 12 18.0983 12 18.4865C12 18.6549 12.0806 18.8453 12.2124 18.9698L15.9038 22.7565C16.1748 23.0421 16.5996 23.0494 16.8853 22.7565Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.9ed49d315b3b0c579001912fa198b0ef.svg";
export { ForwardRef as ReactComponent };